import moment from 'moment-timezone';

export function formatParkingTime(time, timezone = null) {
  const FULL_FORMAT = 'h:mma';
  try {
    const parsedTime = timezone ? moment(time).tz(timezone) : moment.parseZone(time);
    return `${parsedTime.format(FULL_FORMAT)}`;
  } catch (error) {
    console.warn('Error Formatting Parking Time');
    console.warn({ error });
    console.warn({ time, timezone });
    return null;
  }
}

export function formatParkingDate(time, timezone = null) {
  const FULL_FORMAT = 'dddd, MMMM Do ';
  const parsedTime = timezone ? moment(time).tz(timezone) : moment.parseZone(time);
  return `${parsedTime.format(FULL_FORMAT)}`;
}
